export function timelineObject(changelog: ReadmeSection): TimelineObject {
    const breakpoint = /(Changelog|\* [0-9][^\s]+)/
    const regexFilter = /\* [0-9]/
    const timeline: TimelineObject = {}
    const splitData = changelog.content.split(breakpoint)
    const version = splitData.filter((data) => data.match(regexFilter) !== null)
    const content = splitData.filter(
        (data) => data !== '' && version.includes(data) === false
    )
    for (let i = 0; i < version.length; i++) {
        timeline[version[i].replace('* ', '')] = content[i].replace('\n ', '')
    }

    return timeline
}
